$(document).on('click', '.scroll-down__button', function() {
    const offset = $(this).offset();

    $('html, body').animate({
        scrollTop: offset.top + 50,
    }, 1000);
});
